import { render, staticRenderFns } from "./inputCenter.vue?vue&type=template&id=6170147c&scoped=true&"
import script from "./inputCenter.vue?vue&type=script&lang=js&"
export * from "./inputCenter.vue?vue&type=script&lang=js&"
import style0 from "./inputCenter.vue?vue&type=style&index=0&id=6170147c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6170147c",
  null
  
)

export default component.exports